// ウィンドウの中心位置を計算する
export const getBrowserWindowCenter = (
  window, // window object
) => {
  const { innerWidth, innerHeight } = window;
  const x = innerWidth / 2 || 0;
  const y = innerHeight / 2 || 0;
  return {
    x,
    y,
  }; // { x: number; y: number; }
};

// 親要素のgetBoundingClientRectを取得する
// 親要素が存在しない場合はbodyのgetBoundingClientRectを返す
export const getBoundingClientRectOfParent = (
  vc, // VueComponent
) => {
  const bRect = document.body.getBoundingClientRect();
  if (!vc) return bRect;
  if (!vc.$el) return bRect;
  if (!vc.$el.parentNode) return bRect;
  const pRect = vc.$el.parentNode.getBoundingClientRect();
  return pRect;
};

export default {
  getBrowserWindowCenter,
  getBoundingClientRectOfParent,
};
